// Core Modules
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// 3rd Party Modules
import { ToastrService } from 'ngx-toastr';

// Services
import { RequestService } from '../../requests/request.service';

// Models
import { Request } from '../../requests/types/request.model';
import { AuthService } from '../../public/auth.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { RegisterComponent } from '../register/register.component';
import { SharedHelperService } from '../shared-helper.service';
import { GLOBAL_SETTINGS } from '../types/global-setting.const';

@Component({
  selector: 'mmb-web-app-user-summary-info',
  templateUrl: './user-summary-info.component.html',
  styleUrls: ['./user-summary-info.component.scss']
})
export class UserSummaryInfoComponent implements OnInit {
  @Input() image: string;
  @Input() name: string;
  @Input() professionalTitle: string;
  @Input() company: string;
  @Input() type: string;
  @Input() createdOnDate: Date;
  @Input() id: number;
  @Input() isUser: boolean;
  @Input() popoverSummary: string;
  @Input() userUrl: string;
  @Input() orgUrl: string;
  @Input() redirect: string;
  @Input() isSaved: boolean;
  @Input() isDetailpage: boolean;
  @Input() isSaveDisabled: boolean;
  @Input() request: Request;
  @Input() badge: string;
  @Input() truncate: any = GLOBAL_SETTINGS.request.truncate;
  @Output() addBookmark: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeBookmark: EventEmitter<any> = new EventEmitter<any>();

  /**
  * constructor
  * @param RequestService: requestService
  * @param ToastrService: toastr
  */
  constructor(
    private requestService: RequestService,
    private toastr: ToastrService,
    private authService: AuthService,
    private modalService: NgbModal,
    private sharedHelperService: SharedHelperService
  ) { }

  /**
 * Life Cycle Methods
 */
  ngOnInit() {
  }

  /**
   * Add forum item to favorites
   * @param {any} event
   * @param {Request} opportunity
   */
  onAddToFavorites(req: Request, event: any) {
    if (!this.authService.isAuthenticated$.value) {
      this.sharedHelperService.openRegisterModal(null, null, 'You\'re trying to save this opportunity');
    } else {
      this.addBookmark.emit(req);
    }
    event.stopPropagation();
  }

  /**
   * Remove forum item from favorites
   * @param {any} event
   * @param {Request} opportunity
   */
  onRemoveFromFavorites(req: Request, event: any) {
    if (!this.authService.isAuthenticated$.value) {
      this.sharedHelperService.openRegisterModal();
    } else {
      this.removeBookmark.emit(req);
    }
    event.stopPropagation();
  }

  getBookmarkTooltip() {
    if (!this.authService.isAuthenticated$.value) {
      return 'Sign up or Log in to use this ';
    }
    return '';
  }

  getRemoveBookmarkTooltip() {
    if (!this.authService.isAuthenticated$.value) {
      return 'Sign up or Log in to use this ';
    }
    return '';
  }
}
